if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle(event) {
      if (event.detail.id != this.id) return;

      if (this.video.paused) return this.video.play();

      this.video.pause();
    }

    disconnectedCallback() {
      document.removeEventListener('video-player:toggle', this.handleToggleRef);
    }

    connectedCallback() {
      /** @type {HTMLVideoElement | null} */
      this.video = this.querySelector('video');

      if (!this.video) return;

      document.addEventListener('video-player:toggle', this.handleToggleRef);
    }
  }

  customElements.define('video-player', VideoPlayer);
}
